import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Curriculum from './pages/Curriculum';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Register from './pages/Register';
import ResetPassword from './pages/ResetPassword';
import UserManagement from './pages/UserManagement';
import Students from './pages/Students';
import Teachers from './pages/Teachers';
import Tracks from './pages/Tracks';
import Groups from './pages/Groups';
import StudentAchievements from './pages/StudentAchievements';
import DevTools from './pages/DevTools';
import Attendance from './pages/Attendance';
import Centers from './pages/Centers';
import PendingRequests from './pages/PendingRequests';
import MyProgress from './pages/MyProgress';
import Leaderboard from './pages/Leaderboard';

import ChangePassword from './pages/ChangePassword';
import BatchImport from './pages/BatchImport';
import Subscriptions from './pages/SubscriptionsNew';
import SupervisorAchievements from './pages/SupervisorAchievements';
import StudentProgress from './pages/StudentProgress';
import TeacherProgress from './pages/TeacherProgress';
import TeacherDailyRecord from './pages/TeacherDailyRecord';
import TeacherAchievementRecords from './pages/TeacherAchievementRecords';
import { useAuth } from './context/AuthContext';

// Component to handle default redirect based on role
const DefaultRedirect = () => {
  const { userProfile } = useAuth();
  
  if (userProfile?.role === 'student') {
    return <Navigate to="/my-progress" replace />;
  }
  return <Navigate to="/dashboard" replace />;
};

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route index element={<DefaultRedirect />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/tracks" element={<Tracks />} />
          <Route path="/groups" element={<Groups />} />
          <Route path="/teachers" element={<Teachers />} />
          <Route path="/students" element={<Students />} />
          <Route path="/achievements" element={<StudentAchievements />} />
          <Route path="/attendance" element={<Attendance />} />
          <Route path="/curriculum" element={<Curriculum />} />
          <Route path="/users" element={<UserManagement />} />
          <Route path="/dev-tools" element={<DevTools />} />
          {/* New Routes */}
          <Route path="/centers" element={<Centers />} />
          <Route path="/pending-requests" element={<PendingRequests />} />
          <Route path="/my-progress" element={<MyProgress />} />
          <Route path="/leaderboard" element={<Leaderboard />} />

          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/batch-import" element={<BatchImport />} />
          <Route path="/subscriptions" element={<Subscriptions />} />
          <Route path="/supervisor-achievements" element={<SupervisorAchievements />} />
          <Route path="/student-progress" element={<StudentProgress />} />
          <Route path="/teacher-progress" element={<TeacherProgress />} />
          <Route path="/daily-record" element={<TeacherDailyRecord />} />
          <Route path="/achievement-records" element={<TeacherAchievementRecords />} />
        </Route>
      </Route>
      <Route path="*" element={<DefaultRedirect />} />
    </Routes>
  );
}

export default App;
